$shm_hitalama_vk_token_switch $shm_hitalama_components_embed
	current null $shm_hitalama_vk_token
